
import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../payment.service';
import * as crypto from 'crypto-js';
import{MD5} from 'crypto-js';




import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../views/auth/auth.service';
import { formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RedirectService } from './redirect.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-paymentform',
  templateUrl: './paymentform.component.html',
  styleUrls: ['./paymentform.component.css']
})
export class PaymentformComponent implements OnInit {
 
  public paymentForm: FormGroup;

  email$: string;
  tel$:string
  data: any;
  adresse$: string;
  ville$: string;
  fullname$: string;
  birthdate$:string;
  name: string;
  showPopup = false;
  showPopups = false;
  closeResult: string;
  
  public sidebarMinimized = false;
  NumSite = 'MAR982';
  Password = '4e30333c14cc716460ae775cd11898aa';
  Amount = '';
  Devise = 'TND';
  orderProducts=' '
  randomd = Date()

  public registerForm: FormGroup;
orderId:any;
originalString:any;
hash:any;
signature:any;
Plan:String;
duration:any;
  orderch: string;
  firstName: string;
  lastName: string;
  hash1: any;




  constructor( private formBuilder: FormBuilder,private paymentService:PaymentService ,private http: HttpClient,
    public router: Router,private authService: AuthService , private redirectService: RedirectService, private modalService: NgbModal) {}
     

    
  ngOnInit(): void {
  
  this.Plan = localStorage.getItem('Plan')
   this.email$ = localStorage.getItem('email')
   this.authService.EmailsList(this.email$).subscribe(data=>{
   this.tel$=data.body['tel'];
   this.adresse$=data.body['adresse'];
   this.ville$=data.body['ville'];
   this.fullname$=data.body['fullname'].split(' ');
   this.birthdate$= formatDate(data.body['birthdate'], "dd/MM/yyyy", "en");

  });



   this.registerForm = this.formBuilder.group({
  
     nom:[""],
     tel:[""],
     adresse:[""],
     prenom :  [""]

    
   } )


  
    switch(this.Plan) {
      case 'basic':
        this.duration = 1 +" jour";
        this.Amount="1000"
        this.orderProducts="Abonnement basique du robo-advisor"
        break;
      case 'intermediate':
        this.duration = 7 +" jours";
        this.Amount="5000"
        this.orderProducts="Abonnement intermédiare du robo-advisor"
        break;
      case 'advanced':
       this.duration = 30 +" jours";
       this.Amount="10000"
       this.orderProducts="Abonnement avancé du robo-advisor"
        break;
      default:
        console.error('Type d\'abonnement inconnu');
        break;
    }



    this.hash1=MD5(this.randomd);
this.orderId = this.hash1.toString(crypto.enc.Hex).substring(0, 24)
  
 this.orderch= "# "+ this.orderId 
    //console.log(this.orderId);     
    this.originalString=this.NumSite+"es@wmZ39"+this.orderId+this.Amount+this.Devise;
    //console.log(this.originalString);     
    this.hash = crypto.SHA1(this.originalString);
    this.signature=(this.hash).toString();
    //console.log(this.signature);


    }

    change(){
      const nameParts = this.fullname$.split(' ');
      console.log(this.fullname$)
      console.log(nameParts)
      this.firstName = nameParts[0];
      this.lastName = nameParts[nameParts.length - 1];
    }

    
 
    get formControl() {
      return this.registerForm.controls;
    }


    get nom(){
      return this.registerForm.get("nom")
    }

    get tel(){
      return this.registerForm.get("tel")
    }
    get adresse(){
      return this.registerForm.get("adresse")
    }

    get prenom(){
      return this.registerForm.get("prenom")
    }
    gotoSubs(){
      this.router.navigate['/Subscription']
    }
    

  
    onSubmit() {
      if (!this.name) {
        this.showPopup = true;
      } else {
        // Submit form
      }
    }
  
    closePopup() {
      this.showPopup = false;
    }
  



Payment(){
  
  if (this.registerForm.get("nom").value==""||this.registerForm.get("tel").value==""|| this.registerForm.get("adresse").value==""|| this.registerForm.get("prenom").value==""){
  this.onSubmit()
  }
  else{


  let formadata =new FormData()

  formadata.append('NumSite',this.NumSite)
  formadata.append('Password',this.Password)
  formadata.append('orderID',this.orderId)
  formadata.append('EMAIL',this.email$)
  formadata.append('CustLastName',this.registerForm.get("nom").value)
  formadata.append('CustFirstName',this.registerForm.get("prenom").value)
  formadata.append('CustAddress',this.registerForm.get("adresse").value)
  formadata.append('CustTel',this.registerForm.get("tel").value)
  formadata.append('Langue',"fr")
  formadata.append('Amount',this.Amount)
  formadata.append('Currency',"TND")
  formadata.append('PayementType',"1")
  formadata.append('orderProducts',this.orderProducts)
  formadata.append('signature',this.signature)
  formadata.append('vad',"336500003")
  formadata.append('Terminal',"001")
 
//console.log(formadata);

this.paymentService.AddPayment(formadata).subscribe(
  data =>{

console.log ("payment saved");

  },
  error => {
console.log(error,"error");

   }
);


const jsonObject = {};
formadata.forEach((value, key) => {
  if (jsonObject.hasOwnProperty(key)) {
    jsonObject[key] = [].concat(jsonObject[key], value);
  } else {
    jsonObject[key] = value;
  }
});

console.log(jsonObject)

this.redirectService.postRedirect(jsonObject);
  
}

  


};

   
logout(content):void {
  //27/12/2022
  this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}


signout():void{
  this.authService.logout(this.email$).subscribe(
    data => {

    localStorage.setItem('token', '')
    localStorage.setItem('email','')
    this.router.navigate(['/']);

   


    },
    error => {
      console.log(error, 'error')
      if (error.status == 404) {
       
      }
      else if (error.status == 401) {
        
      }

    }
  );
  
}
toggleMinimize(e) {
  this.sidebarMinimized = e;
}



Gotoprofile(){

this.router.navigate(['/Profile/profile']);

}

GotoprofileSecurity(){

this.router.navigate(['profilesecurity/profilesecurity']);

}


GotoSupport(){

this.router.navigate(['support/support']);

}


GotoAbonnement(){

this.router.navigate(['accountbilling/accountbilling']);

}
 


}
